import { withDependencies } from '@wix/thunderbolt-ioc'
import { ICompsLifeCycle } from '@wix/thunderbolt-symbols'

type CompCallbacks = { [compId: string]: { callbacks: { [callbackName: string]: Function } } }
const omitSingle = (key: string, { [key]: _, ...obj }) => obj

export const CompsLifeCycle = withDependencies(
	[],
	(): ICompsLifeCycle => {
		const onCompRenderedCallbacks: CompCallbacks = {}
		const registerToCompLifeCycle: ICompsLifeCycle['registerToCompLifeCycle'] = (
			compIds,
			callbackName,
			callback
		) => {
			compIds.forEach((compId) => {
				onCompRenderedCallbacks[compId] = onCompRenderedCallbacks[compId] || {}
				if (!onCompRenderedCallbacks[compId].callbacks) {
					onCompRenderedCallbacks[compId].callbacks = { [callbackName]: callback }
				} else {
					onCompRenderedCallbacks[compId].callbacks[callbackName] = callback
				}
			})
		}

		const notifyCompDidMount: ICompsLifeCycle['notifyCompDidMount'] = (compId, displayedId) => {
			if (onCompRenderedCallbacks[compId]) {
				Object.values(onCompRenderedCallbacks[compId].callbacks).forEach((cb: Function) => {
					cb(compId, displayedId, document.getElementById(displayedId))
				})
			}
		}

		const unregisterToCompLifeCycle: ICompsLifeCycle['unregisterToCompLifeCycle'] = (compIds, callbackName) => {
			compIds.forEach((compId) => {
				onCompRenderedCallbacks[compId].callbacks = omitSingle(
					callbackName,
					onCompRenderedCallbacks[compId].callbacks
				)
			})
		}

		return {
			registerToCompLifeCycle,
			unregisterToCompLifeCycle,
			notifyCompDidMount,
		}
	}
)
